import MediaInserterSelector from '@intercom/embercom-composer/components/media-inserter-facebook';
export default MediaInserterSelector;
